import React from 'react';
import './ModeToggle.css';

const MODES = [
  {
    id: 'HOME',
    label: 'Home',
    icon: '🏠',
    description: 'Visitors can ring & call',
    color: 'var(--mode-home)'
  },
  {
    id: 'AWAY',
    label: 'Away',
    icon: '🧳',
    description: 'Request callback or message',
    color: 'var(--mode-away)'
  },
  {
    id: 'DND',
    label: 'Do Not Disturb',
    icon: '🔕',
    description: 'Messages only',
    color: 'var(--mode-dnd)'
  }
];

const ModeToggle = ({ currentMode, onModeChange }) => (
  <div className="mode-toggle">
    {MODES.map(mode => (
      <button
        key={mode.id}
        className={`mode-btn ${currentMode === mode.id ? 'mode-btn--active' : ''}`}
        style={currentMode === mode.id ? { '--mode-color': mode.color } : {}}
        onClick={() => onModeChange(mode.id)}
      >
        <span className="mode-icon">{mode.icon}</span>
        <div className="mode-info">
          <span className="mode-label">{mode.label}</span>
          <span className="mode-desc">{mode.description}</span>
        </div>
        {currentMode === mode.id && (
          <span className="mode-active-dot" style={{ background: mode.color }} />
        )}
      </button>
    ))}
  </div>
);

export default ModeToggle;
